import loadWorksJA, { WorksJAMeta } from './works_ja';
import loadWorksZH, { WorksZHMeta } from './works_zh';

const worksSources = {
  zh: {
    meta: WorksZHMeta,
    load: loadWorksZH,
  },
  ja: {
    meta: WorksJAMeta,
    load: loadWorksJA,
  },
};

export default worksSources;
